export default __webpack_public_path__ + "static/media/3.b57cc91b.jpeg";